module.exports = __webpack_public_path__ + "img/avatar-33.829d2612.png";